<div class="container">
  <h1>Gestion des Catégories</h1>

  <!-- Formulaire pour ajouter ou mettre à jour une catégorie -->
  <form (ngSubmit)="saveCategory()">
    <div class="input-container">
      <label for="title">Titre de la catégorie :</label>
      <input type="text"
             id="title"
             class="form-control"
             [(ngModel)]="selectedCategory.title"
             name="title"
             required />
    </div>

    <div class="input-container">
      <label for="slug">Slug :</label>
      <input type="text"
             id="slug"
             class="form-control"
             [(ngModel)]="selectedCategory.slug"
             name="slug"
             required />
    </div>

    <div class="input-container">
      <label for="specs">Spécifications :</label>
      <textarea id="specs"
                class="form-control"
                [(ngModel)]="selectedCategory.specs"
                name="specs"></textarea>
    </div>

    <div class="input-container">
      <label for="image">Sélectionner une image :</label>
      <input type="file"
             id="image"
             class="form-control"
             (change)="onFileSelected($event)"
             accept="image/*" />
    </div>

    <button type="submit" class="btn btn-primary">{{ isUpdating ? 'Mettre à jour la catégorie' : 'Ajouter la catégorie' }}</button>
  </form>

  <!-- Message d'erreur si besoin -->
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <!-- Liste des catégories existantes -->
  <div *ngIf="categories.length > 0" class="category-list">
    <h2>Catégories existantes</h2>
    <ul>
      <li *ngFor="let category of categories">
        <img *ngIf="category.imagePath" [src]="getImageUrl(category.imagePath)" alt="{{category.title }}" />

        <strong>{{ category.title }}</strong> - {{ category.slug }}
        <p>{{ category.specs }}</p>
        <button (click)="editCategory(category)">Modifier</button>
        <button (click)="deleteCategory(category.id)">Supprimer</button>
      </li>
    </ul>
  </div>
</div>
